import React from "react";
import Footer from "./footer";
import SectionTitle from "./section-title";
import Leaders from "./leaders";
import Promise from "./promise";
import Uniform from "./uniform";

function Cubs() {
  return (
    <div className="cubs" id="cubs">
      <SectionTitle section={"cubs"} />
      <Leaders section={"cubs"} />
      <Promise
        section={"cubs"}
      />
      <Uniform 
        section={"cubs"}
      />
      <Footer />
    </div>
  );
}

export default Cubs;
